import { type QuotingProspect } from 'utils/web_api.schemas'
import { useWindowLocation } from 'utils/windowLocation'

import { type MetadataConfiguration } from '../types'
import { resolveNextStepPath } from '../utils'
import CreateOrUpdateProspect, { type CreateOrUpdateProspectProps } from './CreateOrUpdateProspect'

type Props = Omit<CreateOrUpdateProspectProps, 'onSuccess'> & {
  nextStepPath: string,
  autoImportCensusId?: string,
  metadataConfiguration: MetadataConfiguration
}

export function CreateProspect ({ nextStepPath, autoImportCensusId, ...props }: Props) {
  const { replace } = useWindowLocation()

  const onSuccess = (prospect: QuotingProspect) => {
    let path = resolveNextStepPath(nextStepPath, prospect.id)
    if (autoImportCensusId) {
      if (path.includes('?')) {
        path += `&census_id=${encodeURIComponent(autoImportCensusId)}`
      } else {
        path += `?census_id=${encodeURIComponent(autoImportCensusId)}`
      }
    }
    replace(path)
  }

  return (
    <div className='flex justify-center'>
      <CreateOrUpdateProspect {...props} autoImportCensusId={autoImportCensusId} onSuccess={onSuccess} />
    </div>
  )
}

export default (props: Props) => {
  return (
    <CreateProspect {...props} />
  )
}
